import { getChatIntegrationDataHook } from "./integrationDataHooks";

import { registerSchemaHooks } from "@/features/integrations/shared/renderer/hooks/schemaRegistry";

registerSchemaHooks("chat", {
  getIntegrationDataHook: getChatIntegrationDataHook,
});
